module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-lg-4622ed4e.svg";